import LoginModel from "../Domain/Login.model";
import { LoginService } from "../Infrastructure/Auth.service";

export default async function LoginLogic(email, password) {
  const credentials = new LoginModel({email, password})
  return LoginService(credentials);
}
